export const COMPANY_NAME = 'ООО «Сервис-Мастер»';
export const COMPANY_SHORT = 'Сервис-Мастер';
export const COMPANY_INITIALS = 'СМ';
export const CONTRACT_NUMBER = 'ЛГ-2481';
export const MANAGER_NAME = 'Анастасия';
export const MANAGER_EMAIL = 'client@kefir-media.ru';

export const CITIES = [
    {
        id: 'moscow', name: 'Москва', region: 'Московская обл.', regionShort: 'МО', regionType: 'mo',
        priceFactor: 1, weight: 10,
        districts: ['ЦАО', 'САО', 'СВАО', 'ВАО', 'ЮВАО', 'ЮАО', 'ЮЗАО', 'ЗАО', 'СЗАО', 'ЗелАО'],
        regionTowns: ['Химки', 'Балашиха', 'Подольск', 'Красногорск', 'Мытищи', 'Королёв', 'Люберцы', 'Одинцово'],
        defaultCityOn: true, defaultRegionOn: true, defaultDistrictsOff: []
    },
    {
        id: 'spb', name: 'Санкт-Петербург', region: 'Ленинградская обл.', regionShort: 'ЛО', regionType: 'lo',
        priceFactor: 0.9, weight: 7,
        districts: ['Центральный', 'Адмиралтейский', 'Василеостровский', 'Выборгский', 'Калининский', 'Кировский', 'Московский', 'Невский', 'Петроградский', 'Приморский'],
        regionTowns: ['Гатчина', 'Выборг', 'Всеволожск', 'Сосновый Бор', 'Тосно'],
        defaultCityOn: true, defaultRegionOn: false
    },
    {
        id: 'ekb', name: 'Екатеринбург', region: 'Свердловская обл.', regionShort: 'Свердловская обл.', regionType: 'region',
        priceFactor: 0.75, weight: 4,
        districts: ['Верх-Исетский', 'Железнодорожный', 'Кировский', 'Ленинский', 'Октябрьский', 'Орджоникидзевский', 'Чкаловский'],
        regionTowns: ['Нижний Тагил', 'Каменск-Уральский', 'Первоуральск'],
        defaultCityOn: true, defaultRegionOn: false
    },
    {
        id: 'kazan', name: 'Казань', region: 'Республика Татарстан', regionShort: 'Татарстан', regionType: 'region',
        priceFactor: 0.7, weight: 4,
        districts: ['Авиастроительный', 'Вахитовский', 'Кировский', 'Московский', 'Ново-Савиновский', 'Приволжский', 'Советский'],
        regionTowns: ['Набережные Челны', 'Нижнекамск', 'Альметьевск'],
        defaultCityOn: true, defaultRegionOn: true
    },
    {
        id: 'krasnodar', name: 'Краснодар', region: 'Краснодарский край', regionShort: 'край', regionType: 'region',
        priceFactor: 0.75, weight: 4,
        districts: ['Западный', 'Карасунский', 'Прикубанский', 'Центральный'],
        regionTowns: ['Новороссийск', 'Сочи', 'Армавир'],
        defaultCityOn: true, defaultRegionOn: true
    },
    {
        id: 'novosibirsk', name: 'Новосибирск', region: 'Новосибирская обл.', regionShort: 'Новосибирская обл.', regionType: 'region',
        priceFactor: 0.7, weight: 3,
        districts: ['Дзержинский', 'Железнодорожный', 'Заельцовский', 'Калининский', 'Кировский', 'Ленинский', 'Октябрьский', 'Советский'],
        regionTowns: ['Бердск', 'Искитим'],
        defaultCityOn: false, defaultRegionOn: false
    },
    {
        id: 'nn', name: 'Нижний Новгород', region: 'Нижегородская обл.', regionShort: 'Нижегородская обл.', regionType: 'region',
        priceFactor: 0.7, weight: 3,
        districts: ['Автозаводский', 'Канавинский', 'Ленинский', 'Московский', 'Нижегородский', 'Приокский', 'Советский', 'Сормовский'],
        regionTowns: ['Дзержинск', 'Арзамас'],
        defaultCityOn: false, defaultRegionOn: false
    },
    {
        id: 'rostov', name: 'Ростов-на-Дону', region: 'Ростовская обл.', regionShort: 'Ростовская обл.', regionType: 'region',
        priceFactor: 0.7, weight: 3,
        districts: ['Ворошиловский', 'Железнодорожный', 'Кировский', 'Ленинский', 'Октябрьский', 'Первомайский', 'Пролетарский', 'Советский'],
        regionTowns: ['Таганрог', 'Новочеркасск'],
        defaultCityOn: true, defaultRegionOn: false
    },
    {
        id: 'samara', name: 'Самара', region: 'Самарская обл.', regionShort: 'Самарская обл.', regionType: 'region',
        priceFactor: 0.65, weight: 3,
        districts: ['Промышленный', 'Кировский', 'Куйбышевский', 'Ленинский', 'Октябрьский', 'Самарский', 'Советский', 'Железнодорожный'],
        regionTowns: ['Тольятти', 'Сызрань'],
        defaultCityOn: false, defaultRegionOn: false
    },
    {
        id: 'chelyabinsk', name: 'Челябинск', region: 'Челябинская обл.', regionShort: 'Челябинская обл.', regionType: 'region',
        priceFactor: 0.65, weight: 2,
        districts: ['Калининский', 'Курчатовский', 'Ленинский', 'Металлургический', 'Советский', 'Тракторозаводский', 'Центральный'],
        regionTowns: ['Магнитогорск', 'Златоуст'],
        defaultCityOn: false, defaultRegionOn: false
    },
    {
        id: 'voronezh', name: 'Воронеж', region: 'Воронежская обл.', regionShort: 'Воронежская обл.', regionType: 'region',
        priceFactor: 0.6, weight: 2,
        districts: ['Железнодорожный', 'Коминтерновский', 'Левобережный', 'Ленинский', 'Советский', 'Центральный'],
        regionTowns: ['Нововоронеж', 'Россошь'],
        defaultCityOn: false, defaultRegionOn: false
    }
];

export const DIRECTION_BASE_PRICES = {
    'fridges': 640,
    'washing-machines': 590,
    'dishwashers': 560,
    'electric-stoves': 520,
    'coffee-machines': 780,
    'water-heaters': 540,
    'vacuum-cleaners': 420,
    'appliance-install': 460,
    'ovens-hobs': 540,
    'microwaves': 380,
    'dryers': 610,
    'gas-boilers': 720,
    'cold-storage': 950,
    'sewing-machines': 400
};

export const DEFAULT_ACTIVE_DIRECTIONS = [
    'fridges', 'washing-machines', 'dishwashers', 'electric-stoves',
    'coffee-machines', 'water-heaters', 'vacuum-cleaners', 'appliance-install'
];

export const PENDING_DIRECTIONS = ['ovens-hobs', 'microwaves'];

export const LEAD_STATUSES = ['new', 'progress', 'called', 'deal', 'declined'];

export const LEAD_STATUS_LABELS = {
    new: 'Новая',
    progress: 'В работе',
    called: 'Дозвонились',
    deal: 'Сделка',
    declined: 'Отказ клиента',
    review: 'На проверке'
};

export const SOURCES = ['Заявка с сайта', 'Звонок'];

export const DISPUTE_REASONS = [
    { id: 'duplicate', label: 'Дубль' },
    { id: 'wrong-area', label: 'Не наш район' },
    { id: 'non-target', label: 'Нецелевой запрос' },
    { id: 'wrong-number', label: 'Неверный номер / не дозвонились за 24 часа' },
    { id: 'other', label: 'Другое' }
];

export const FIRST_NAMES = ['Ольга', 'Андрей', 'Татьяна', 'Ирина', 'Роман', 'Анна', 'Валентина', 'Сергей', 'Наталья', 'Дмитрий', 'Елена', 'Михаил', 'Светлана', 'Алексей', 'Марина', 'Виктор', 'Юлия', 'Павел', 'Людмила', 'Николай'];

export const APPLIANCE_BRANDS = {
    'fridges': ['Atlant', 'LG', 'Samsung', 'Bosch', 'Indesit', 'Beko'],
    'washing-machines': ['LG', 'Bosch', 'Samsung', 'Indesit', 'Electrolux', 'Candy'],
    'dishwashers': ['Bosch', 'Electrolux', 'Hansa', 'Gorenje'],
    'electric-stoves': ['Hansa', 'Gorenje', 'Electrolux', 'Beko'],
    'coffee-machines': ['DeLonghi', 'Philips', 'Bosch', 'Jura'],
    'water-heaters': ['Ariston', 'Thermex', 'Electrolux'],
    'vacuum-cleaners': ['Dyson', 'Samsung', 'Xiaomi', 'Philips'],
    'appliance-install': [],
    'ovens-hobs': ['Electrolux', 'Bosch', 'Hansa', 'Gorenje'],
    'microwaves': ['Samsung', 'LG', 'Bosch'],
    'dryers': ['Miele', 'Bosch', 'Electrolux'],
    'gas-boilers': ['Baxi', 'Ariston', 'Vaillant'],
    'cold-storage': ['Polair', 'Cryspi'],
    'sewing-machines': ['Brother', 'Janome', 'Singer']
};

export const PROBLEM_TEXTS = {
    'fridges': ['не морозит нижняя камера', 'сильно шумит компрессор', 'не держит температуру', 'течёт вода внутри'],
    'washing-machines': ['не сливает воду', 'стучит при отжиме', 'не крутит барабан', 'протекает снизу'],
    'dishwashers': ['не включается, горит ошибка', 'не моет верхнюю корзину', 'не сливает воду'],
    'electric-stoves': ['не работает одна конфорка', 'духовка не греет', 'не включается'],
    'coffee-machines': ['не мелет зерно', 'протекает вода', 'не греет'],
    'water-heaters': ['греет воду слишком долго', 'выбивает автомат', 'течёт бак'],
    'vacuum-cleaners': ['пропала тяга', 'перегревается', 'не включается'],
    'appliance-install': ['нужно подключить новую технику', 'нужна установка под столешницей'],
    'ovens-hobs': ['духовка не греет до нужной температуры', 'не работает конфорка'],
    'microwaves': ['искрит внутри камеры', 'не крутится тарелка'],
    'dryers': ['бельё остаётся влажным', 'не включается'],
    'gas-boilers': ['гаснет через пару минут', 'не включается розжиг'],
    'cold-storage': ['не держит температуру', 'течёт фреон'],
    'sewing-machines': ['пропускает стежки', 'рвёт нить']
};
